<template>

<div v-if="loading == true" class="absolute bg-gray-900  w-screen z-20 h-screen top-0">
  {{  loading }}
    <div  class="lds-heart"><div></div></div>
</div>
</template>

<script>
export default {
      data() {
        return{
            
        }
      },
      props:{
        loading : Boolean
      }
}
</script>

<style>

.lds-heart {
  top: 40%;
  left: 50%;
  transform: translate(-50% , -50%);
  display: inline-block;
  position: relative;
  
  transform: rotate(45deg);
  
}
.lds-heart div {
  top: 32px;
  left: 32px;
  position: absolute;
  width: 32px;
  height: 32px;
  background: red;
  animation: lds-heart 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
}
.lds-heart div:after,
.lds-heart div:before {
  content: " ";
  position: absolute;
  display: block;
  width: 32px;
  height: 32px;
  background: red;
}
.lds-heart div:before {
  left: -24px;
  border-radius: 50% 0 0 50%;
}
.lds-heart div:after {
  top: -24px;
  border-radius: 50% 50% 0 0;
}
@keyframes lds-heart {
  0% {
    transform: scale(0.95);
  }
  5% {
    transform: scale(1.1);
  }
  39% {
    transform: scale(0.85);
  }
  45% {
    transform: scale(1);
  }
  60% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(0.9);
  }
}

</style>